
<router-outlet></router-outlet>
<!-- <ngx-spinner
[fullScreen] = "true"
bdColor="#ffffff5"
size="medium"
name="general"
color="#8a0808"
type="timer">
<p style="color: #000000">Espere...</p>
</ngx-spinner>

<ngx-spinner
[fullScreen] = "true"
bdColor="#ffffff5"
size="medium"
color="#8a0808"
name="menu"
type="timer">
<p style="color: #000000">Espere...</p>
</ngx-spinner> -->

<easy-spinner name="login" text="Ingresando..." image="/assets/images/spinner.svg"></easy-spinner>
<easy-spinner name="menu" text="Cargando..." image="/assets/images/spinner.svg"></easy-spinner>
<easy-spinner name="general" text="Enviando..." image="/assets/images/spinner.svg"></easy-spinner>